import styled from '@emotion/styled';
import { useRouter } from 'next/router';
import { useState } from 'react';
import { Toast } from '@components/_atoms/Toast';
import { useQueryClient } from 'react-query';

// components
import Button from '@components/_atoms/Button';
import DefaultButtonBox from '@components/_molecules/DefaultButtonBox';
import CompanyRegistrationNumberBox from '@components/_organism/user/CompanyRegistrationNumberBox';

// constants
import { ButtonColor, ButtonType } from '@constants/atoms';
import { MOBILE_MODE } from '@constants/size';

// hooks
import { usePatchUserCompanyInfoFetch } from '@hooks/fetch/useUserFetch';

// type
import { EditCompanyInfoFormType } from '../types';
import ButtonCode from '@constants/log/buttonCode';

const Layout = styled.form``;

const CompanyRegistrationNumberWrapper = styled.div`
  margin-bottom: 80px;

  @media ${MOBILE_MODE} {
    margin-bottom: 184px;
  }
`;

export default function CompanyInfoEditForm() {
  const router = useRouter();
  const queryClient = useQueryClient();

  const [form, setForm] = useState<EditCompanyInfoFormType>({
    company_registration_number: '',
    company_name: '',
    company_address: '',
    company_ceo: '',
  });
  const [isCompanyInfoValid, setIsCompanyInfoValid] = useState(false);

  const { patchUserCompanyInfoFetchMutate } = usePatchUserCompanyInfoFetch();

  // 사업자 등록번호 변경 submit
  const handleFormSubmit = () => {
    patchUserCompanyInfoFetchMutate(
      { ...form },
      {
        onSuccess: () => {
          router.back();
          Toast.success('변경 내용을 저장했어요.');
          queryClient.invalidateQueries(['user']);
        },
      },
    );
  };

  return (
    <Layout
      onSubmit={(e) => {
        e.preventDefault();
        handleFormSubmit();
      }}>
      <CompanyRegistrationNumberWrapper>
        <CompanyRegistrationNumberBox data={form} setData={setForm} setIsValid={setIsCompanyInfoValid} />
      </CompanyRegistrationNumberWrapper>

      <DefaultButtonBox
        button1={
          <Button
            text="이전으로"
            type={ButtonType.Button}
            color={ButtonColor.OutlinedBlack}
            onClick={() => router.back()}
            steelbosoId={ButtonCode.BTN_BACK}
          />
        }
        button2={
          <Button disabled={!isCompanyInfoValid} text="변경 내용 저장하기" steelbosoId={ButtonCode.BTN_SUBMIT} onClick={handleFormSubmit} />
        }
      />
    </Layout>
  );
}
